<template>
  <div>
    <b-button
      class="badge badge-secondary badge-xs mr-2"
      :href="linkReisetermin"
      target="_blank"
      style="width: 30px"
    >
      <a>
        <div class="fas fa-info" style="color: #000"></div>
      </a>
    </b-button>
    <b-button
      class="badge badge-secondary badge-xs"
      target="_blank"
      @click="createAufgabe"
      style="width: 30px"
      v-b-tooltip.hover
      :title="'Aufgabe erstellen'"
    >
      <ListChecks :size="14"></ListChecks>
    </b-button>
  </div>
</template>

<script>
import { ListChecks } from 'lucide-vue';

export default {
  components: { ListChecks },
  computed: {
    linkReisetermin() {
      const reiseterminId = this.params.data.hotelleistungen.filter(hl => hl.isDeleted == false)[0]
        ?.reisetermin?.id;
      if (reiseterminId == null) return '#';
      return `/#/reisetermine/${reiseterminId}/?vorgangdetailstab=fluege&scrollToFlugdaten=true`;
    },
  },
  methods: {
    createAufgabe() {
      // alle Reisetermine aus den Hotelleistungen, die nicht gelöscht sind
      const reisetermine = this.params.data.hotelleistungen
        .filter(hotelleistung => hotelleistung.isDeleted === false)
        .map(hotelleistung => hotelleistung.reisetermin)
        .filter(reisetermin => reisetermin != null);

      const prefixedVerlinkungen = [
        {
          id: 0,
          typ: 'Vorgang',
          artifactId: this.params.data.id,
        },
      ];

      // Füge alle Reisetermine hinzu
      reisetermine.forEach((reisetermin, index) => {
        prefixedVerlinkungen.push({
          id: index + 1,
          typ: 'Reisetermin',
          artifactId: reisetermin.id,
          artifactText: reisetermin.reiseterminkuerzel,
        });
      });

      this.params.onShowModalAufgabeEdit(prefixedVerlinkungen);
    },
  },
};
</script>
<style></style>
